import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ChartLineUp, Receipt, Calendar, ArrowsDownUp, Users, Gear, SignOut, Receipt as ReceiptIcon, CurrencyEur, Warning, Buildings } from "@phosphor-icons/react";

const nav = [
  { to: "/", label: "Dashboard", icon: ChartLineUp, end: true },
  { to: "/avgs", label: "AVGS-Rechnungen", icon: Receipt },
  { to: "/fbw", label: "FBW-Abschläge", icon: Calendar },
  { to: "/mahnwesen", label: "Mahnwesen", icon: Warning },
  { to: "/zahlungen", label: "Zahlungseingänge", icon: ArrowsDownUp },
  { to: "/ausgaben", label: "Fixe Ausgaben", icon: CurrencyEur },
  { to: "/kunden", label: "Teilnehmer", icon: Users },
  { to: "/profil", label: "Unternehmensprofil", icon: Buildings },
  { to: "/einstellungen", label: "Einstellungen", icon: Gear },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };
  return (
    <div className="min-h-screen flex bg-grain">
      <aside
        data-testid="sidebar"
        className="hidden md:flex md:flex-col w-64 shrink-0 bg-[#E6F7F7] border-r border-[#E2E8F0]"
      >
        <div className="px-6 py-7 border-b border-[#E2E8F0]">
          <div className="flex items-center gap-2.5">
            <img
              src="/we-logo.png"
              alt="We Academy"
              className="h-9 w-9 object-contain"
            />
            <div>
              <div className="font-display text-base font-bold text-[#1F242E] leading-none">We finance</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#5B6371] mt-1">We Academy</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-0.5">
          {nav.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`nav-${item.to.replace("/", "") || "dashboard"}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                    isActive
                      ? "bg-[#0AA09E] text-white"
                      : "text-[#1F242E] hover:bg-[#D0F0EF]"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={18} weight={isActive ? "fill" : "duotone"} />
                    <span className="font-medium">{item.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-[#E2E8F0]">
          <div className="px-3 py-2 mb-2">
            <div className="text-xs text-[#5B6371]">Angemeldet als</div>
            <div className="text-sm font-medium text-[#1F242E] truncate" data-testid="current-user-email">
              {user?.email}
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#94A3B8] mt-1">{user?.role}</div>
          </div>
          <button
            onClick={onLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-[#1F242E] hover:bg-[#D0F0EF] transition-colors"
          >
            <SignOut size={16} />
            Abmelden
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        {/* Mobile header */}
        <div className="md:hidden flex items-center justify-between px-4 py-3 border-b border-[#E2E8F0] bg-white">
          <div className="flex items-center gap-2">
            <img
              src="/we-logo.png"
              alt="We Academy"
              className="h-8 w-8 object-contain"
            />
            <div className="font-display font-bold">We finance</div>
          </div>
          <button onClick={onLogout} data-testid="logout-mobile" className="text-sm text-[#5B6371]">
            Abmelden
          </button>
        </div>
        {/* Mobile nav */}
        <nav className="md:hidden flex overflow-x-auto gap-1 px-3 py-2 border-b border-[#E2E8F0] bg-[#E6F7F7]">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-1.5 rounded-md text-xs ${
                  isActive ? "bg-[#0AA09E] text-white" : "text-[#1F242E]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 md:px-8 lg:px-12 py-6 md:py-8 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
